import React, {useState, useRef, useCallback, useEffect} from 'react';
import Plot from 'react-plotly.js';
import Plotly from 'plotly.js-dist'; // Import Plotly
import '../../assets/css/scatterPlot.css';
import ReactDOM from 'react-dom';

function groupByLabel(data, grouping_label = "label", binary_grouping = null) {
  const groupedData = {};

  data.forEach((item, index) => {
      let label = item["groupAttributes"][grouping_label];
      if (binary_grouping != null && label != binary_grouping) {
        label = "other"
      }
      if (!(label in groupedData)) {
        groupedData[label] = [];
      }
      groupedData[label].push({ embedding: item["embedding"], groupAttributes: item["groupAttributes"], instanceAttributes: item["instanceAttributes"] });

  });
  return groupedData;
}

function get_hoverttext(embedding, groupAttributes, instanceAttributes) {
  const rows = [];

  function appendAttributes(attributes) {
    for (let key in attributes) {
      if (attributes.hasOwnProperty(key)) {
        rows.push(`<i>${key}:</i> ${cut_string(attributes[key], 30)}`);
      }
    }
  }
  appendAttributes(groupAttributes)
  appendAttributes(instanceAttributes)
  

  const hovertemplate = 
    "<b>" + embedding.map(value => Number(value).toPrecision(3)).join(', ') + "</b><br><br>" +
    rows.join('<br>') +
    "<extra></extra>"

  return hovertemplate;
}

function insertLineBreaks(text, maxLineLength) {
  let result = '';
  let currentLine = '';

  text.split(' ').forEach(word => {
      // Check if adding the next word would exceed the maximum line length
      if ((currentLine + ' ' + word).trim().length <= maxLineLength) {
          currentLine += (currentLine ? ' ' : '') + word; // Add the word to the current line
      } else {
          // Add a line break and start a new line
          if (currentLine) {
              result += currentLine + '<br>';
          }
          currentLine = word;
      }
  });

  // Add the last segment to the result
  if (currentLine) {
      result += currentLine;
  }

  return result;
}

function cut_string(str, maxLength) {
  // Cut string if longer than maxLength and append "..."
  if (typeof str === 'string' && str.length > maxLength) {
    str = str.substring(0, maxLength) + "...";
  }
  return str;
}

function removeLineBreaks(formattedText) {
  // Simply replace all occurrences of <br> with a space to reconstruct the original string
  return formattedText.replace(/<br>/g, ' ');
}


const ScatterPlot = ({ data, grouping_label, searchValue, get_by_id, setNumHighlighted, instanceID=null, searchType=null, is3D=false }) => {
  const [modalInfo, setModalInfo] = useState({x: null, y: null, z: null});
  const [highlighted, setHighlighted] = useState(null);
  const [previousSearchValue, setPreviousSearchValue] = useState("");
  const plotRef = useRef(null);
  var instanceCoordinates = null;
  var num_highlighted = 0
  setNumHighlighted(0)
  //const highlightedPointSize = 8 //searchType === "instance" ? 8 : 4

  for (const i in data) {
    if (Object.keys(data[i]).includes("previousGroups") && data[i]["groupAttributes"][grouping_label] != searchValue) {
      var point = data[i]
      data.splice(i, 1)
      point["groupAttributes"][grouping_label] = point["previousGroups"][grouping_label]
      delete point["previousGroups"]
      data.push(point)
    }
  }

  if (searchType === "instance" && instanceID != null) {
    for (const i in data) {
      if (data[i]["instanceAttributes"]["id"] === instanceID) {
        var point = data[i]
        data.splice(i, 1)
        if (point["groupAttributes"][grouping_label] != searchValue) {
          point["previousGroups"] = {}
          point["previousGroups"][grouping_label] = point["groupAttributes"][grouping_label]
        }
        point["groupAttributes"][grouping_label] = searchValue
        instanceCoordinates = point["embedding"]
        data.push(point)
      } 
    }
  }


  // Prepare the plot data and layout
  let binary_grouping = searchType === "group" || searchType === "instance" ? searchValue : null
  
  //let grouped_label = binary_grouping ? searchValue : grouping_label
  let groupedData = groupByLabel(data, grouping_label, binary_grouping=binary_grouping)
  if (binary_grouping != null) {
    var num_grouping = groupedData[binary_grouping].length
    const keyNotOther = Object.keys(groupedData).find(key => key !== "other");
    num_highlighted = keyNotOther ? groupedData[keyNotOther].length : 0;
    setNumHighlighted(num_highlighted)
  }

  var plot_data = []
  var idx = 0

  for (const [key, value] of Object.entries(groupedData)) {
    const trace = {
      x: value.map(({ embedding }) => embedding[0]),
      y: value.map(({ embedding }) => embedding[1]),
      mode: 'markers',
      name: insertLineBreaks(key, 30),
      color: "RdBu",
      marker: { 
        size: 4, 
        opacity: 1, //0.5
        /*lighting: {
          ambient: 0.5,
          diffuse: 0.8,
          fresnel: 0.1,
          specular: 0.5,
          roughness: 0.9,
          facenormalsepsilon: 0,
          vertexnormalsepsilon: 0
        }*/
       },
      hovertemplate: value.map(({ groupAttributes, instanceAttributes, embedding }) => get_hoverttext(embedding, groupAttributes, instanceAttributes)),
      
    };

    if (is3D) {
      trace.z = value.map(({ embedding }) => embedding[2]);
      trace.type = 'scatter3d';
    } else {
      trace.type = 'scatter';
    }

    const highlightedPointSize = num_grouping < 50 ? 8 : 4

    if (searchType != null) {
      if (highlighted && removeLineBreaks(trace.name) === highlighted.label) {
        trace.marker = { ...trace.marker, color: 'rgb(255,0,0)', size: highlightedPointSize, opacity: 1 };
      } else {
        trace.marker = { ...trace.marker, color: 'rgb(105,105,105)', size: 4, opacity: 0.1 };
      }
    }
    

    plot_data.push(trace);
    idx += 1
  }
  /*let key = "instance"
  let value = [groupedData["rec.autos"][0]]
  const trace = {
    x: value.map(({ embedding }) => embedding[0]),
    y: value.map(({ embedding }) => embedding[1]),
    mode: 'markers',
    name: key,
    marker: { size: 14, opacity: 0.8 },
    hovertemplate: value.map(({ groupAttributes, instanceAttributes, embedding }) => get_hoverttext(embedding, groupAttributes, instanceAttributes)),
    
  };
  plot_data.push(trace);*/



  let layout = {
    autosize: true,
    scene: {
      camera: {
        center: { x: 0, y: 0, z: 0 },
        eye: { x: 1.25, y: 1.25, z: 1.25 },
        up: { x: 0, y: 0, z: 1 }
      }
    },
    font: {
      family: 'Poppins',
      size: 14,
      color: '#7f7f7f'
    },
    xaxis: {
      title: 'Dimension 1',
    },
    yaxis: {
      title: 'Dimension 2'
    },
    legend: {
      font: {
        family: 'Poppins',
        size: 18,
      },
      itemsizing: "constant"
    },

  };
  if (is3D) {
    layout["zaxis"] = {
      title: 'Dimension 3'
    }
  }

  //ZOOMING FUNCTIONALITY. Does not work yet

  const eyeFactor = 0.1942263408987376

  const print_zoom = () => {
    console.log(plotRef.current.props.layout.scene.camera)
  }

  function calculateY(coordinates) {
    const center = {
      x: coordinates[0] * 0.04974636076,
      y: coordinates[1] * -0.11063873346,
      z: coordinates[2] * -0.04313540273,
    };
    return center
  }
  
  const handleZoom = (coordinates) => {
    if (plotRef.current) {
      if (is3D) {
        const center = calculateY(coordinates)

        Plotly.relayout(plotRef.current.el, {
          'scene.camera': {
            center: { x: center.x, y: center.y, z: center.z }, 
            eye: { x: (center.x+eyeFactor), y: (center.y+eyeFactor), z: (center.z+eyeFactor) }, 
            up: { x: 0, y: 0, z: 1 }
          }
        });
      } else {
        Plotly.relayout(plotRef.current.el, {
          'xaxis.range': [2, 4],
          'yaxis.range': [2, 4]
        });
      }
    }
  };

  const getInfoPopupContent = (headline, content) => {
    return (
      `<div style="display: flex; flex-direction: column; gap: 12px;">
        <h2>` + headline + `</h2>
        <span className="font-medium" style="display:inline-block">` + content + `</span>
      </div>`
    );
  };

  const extractID = (htmlString) => {
    const idMatch = htmlString.match(/<i>id:<\/i>\s*(\d+)/);
    if (idMatch && idMatch[1]) {
      return idMatch[1];
    }
    return null;
  };

  let clickTimeout = null;

  const handlePointClick = (event) => {
    if (clickTimeout !== null) {
        clearTimeout(clickTimeout); 
        clickTimeout = null;
        if (event["points"]) {
          let id = extractID(event["points"][0].hovertemplate)
          get_by_id(id)
          const infoPopup = document.getElementById("scrollable_info_popup")
          infoPopup.style.display = ""
          /*const infoPopup = document.getElementById("scrollable_info_popup")
          if (infoPopup) {
            const infoPopupContent = document.getElementById("scrollable_info_popup_content")
            if (infoPopupContent) {
              //TODO: CHANGE CONTENT AND HEADLINE
              let headline = "Article text:"
              let content = `The Olsen Gang (Danish: Olsen-banden, Norwegian: Olsenbanden) is a Danish comedy film series created by Danish director Erik Balling and special effects expert Henning Bahs about the eponymous fictional criminal gang. The gang's leader is the criminal genius and habitual offender Egon Olsen and his accomplices are Benny and Kjeld (Kjell in Norwegian). The gang members are harmless, extremely rarely target ordinary citizens, and never deliberately use violence.[a] The first film came in 1968; during the next thirty years a total of fourteen films were made. \n\n

              <br /><br />A Norwegian version of the film series was also made (a total of 14 films from 1969 to 1999), in most cases based directly on the scripts for the Danish films. Later, starting in 1981, Sweden also produced their own version: Jönssonligan.[1]
              
              <br /><br />Most of the films start with Egon coming out of jail and being enthusiastically welcomed by Benny and Kjeld. The three men will then have a beer together in the living room of Kjeld's home in Valby, where Egon will inform his friends of his latest plan for making them millionaires. Plans are often two-step plans, where the first heist will get the equipment for the real, second plan. The plans usually feature everyday artifacts such as Lego, party balloons, cigarettes, etc., which are then brought together in surprising ways in elaborate and well-timed plans, often including clever social engineering. Benny's function in the heists, besides get-away-driver, is picking locks and starting machinery using "The Thing", a specially shaped brass piece used for manipulating machinery and opening doors. Egon often serves time in prison with lawyers or executives who provide him with the information he needs, such as duty rosters for the national public record office. Egon is also a brilliant safecracker, operating manually, specializing in the fictive "Franz Jäger" brand.`              
              
              let infoHTML = getInfoPopupContent(headline, content);
              infoPopupContent.innerHTML =  infoHTML
            }
            infoPopup.style.display = ""
          }*/
        }
    } else {
        clickTimeout = setTimeout(() => {
            clickTimeout = null;
        }, 200); // Delay of 200ms to distinguish between single and double clicks
    }
  };

  const closeModal = () => {
    document.getElementById("scatter-modal").style.display = "none"
  }

  if (searchType !== null && previousSearchValue !== searchValue) {
    setPreviousSearchValue(searchValue)
    let highlightedPoint = null;
    for (const [key, value] of Object.entries(groupedData)) {
      for (const point of value) {
        if (typeof point.groupAttributes[grouping_label] === 'string' && point.groupAttributes[grouping_label].includes(searchValue)) {
          highlightedPoint = { label: key, embedding: point.embedding };
          break;
        }
      }
    }
    setHighlighted(highlightedPoint);
  }

  if (searchType === "instance") {
    //handleZoom([targetX, targetY, targetZ]);
    //handleZoom(instanceCoordinates);
  } //TODO: MAKE SURE THIS HANDLES ZOOMING




  //TEST PAN print:
  const handleRelayout = (event) => {
    //console.log(event)
  };

  

  return (
    <>
      <Plot
        ref={(plot) => plotRef.current = plot}
        data={plot_data}
        layout={layout}
        config={{ responsive: true }}  // Ensure the plot is responsive
        className='scatter-container'
        onClick={handlePointClick}
        onRelayout={handleRelayout}
      />
      <div id="scatter-modal" className="modal" style={{display: "none"}}>
          <div className="modal-content">
              <span className="close" onClick={closeModal}>×</span>
              <h2>Point Information</h2>
              <p><strong>X:</strong> {modalInfo.x}</p>
              <p><strong>Y:</strong> {modalInfo.y}</p>
              <p><strong>Z:</strong> {modalInfo.z}</p>
          </div>
      </div>
    </>
  );
};

export default ScatterPlot;

/* 
<button onClick={() => handleZoom([7.62, 1.54, 3.42])}>Zoom</button>
<button onClick={() => calculateY([-0.584, 0.565, 4.95])}>Print Zoom</button>
*/